import { CompletionContext, CompletionResult } from "@codemirror/autocomplete";
import { LRLanguage } from "@codemirror/language";

// Autocomplete for Twig variables {{ variable }}
// Checks if we're typing {{ variable }} or {% if variable %}, {% for item in variable %}, etc.

export function completeTwigVariables(
  context: CompletionContext,
  twigVariables: string[]
): CompletionResult | null {
  const textBefore = context.state.sliceDoc(0, context.pos);

  const outputMatch = textBefore.match(/\{\{\s*([^}]*)$/);

  const setMatch = textBefore.match(/\{%\s*set\s+\w+\s*=\s*([^%]*)$/);
  const forMatch = textBefore.match(/\{%\s*for\s+\w+\s+in\s+([^%]*)$/);
  const ifMatch = textBefore.match(/\{%\s*if\s+([^%]*)$/);

  const match = outputMatch || setMatch || forMatch || ifMatch;
  if (!match) return null;

  const partialVariable = match[1].trim();

  const filteredVariables = twigVariables.filter(variable =>
    variable.toLowerCase().includes(partialVariable.toLowerCase())
  );

  if (filteredVariables.length === 0) return null;

  const options = filteredVariables.map(variable => ({
    label: variable,
    type: "variable",
    section: "Twig Variables"
  }));

  return {
    from: context.pos - partialVariable.length,
    options,
    validFor: /^[a-zA-Z0-9_]*$/
  };
}

export function createTwigVariablesCompletions(
  twigVariables: string[],
  languageDefinition: LRLanguage
) {
  return languageDefinition.data.of({
    autocomplete: (context: CompletionContext) =>
      completeTwigVariables(context, twigVariables)
  });
}
